import React, { Component } from 'react';
import {
    Icon, Upload, Form, Input, Button, Select, Row, Col,
} from 'antd';

class ProfileView extends Component {
    constructor(props) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSubmit(e) {
        e.preventDefault();
        // console.log(e);
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.props.updateProfile(values);
            }
        });
    }

    render() {
        const profilePic = this.props.profilePic;
        const uploadButton = (
            <div>
                <Icon type={this.props.loadingPicture ? 'loading' : 'plus'} />
                <div className="ant-upload-text">
                    Upload
                </div>
            </div>
        );

        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 8 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 16 },
            },
        };
        const tailFormItemLayout = {
            wrapperCol: {
                xs: {
                    span: 24,
                    offset: 0,
                },
                sm: {
                    span: 16,
                    offset: 8,
                },
            },
        };
        const { getFieldDecorator } = this.props.form;
        const email = this.props.email;
        const lang = this.props.lang;
        return (
            <div>
                <h1 className="display-2 mb-5 mt-5">
                    Cuenta de usuario
                </h1>
                <Row gutter={12}>
                    <Col span={6}>
                        <Upload
                            name="avatar"
                            listType="picture-card"
                            className="avatar-uploader"
                            showUploadList={false}
                            beforeUpload={this.props.beforeUploadPicture}
                            onChange={this.props.updateProfilePicture}
                        >
                            {profilePic ? <img src={profilePic} alt="avatar" style={{ maxWidth: '350px' }} /> : uploadButton}
                        </Upload>
                    </Col>

                    <Col span={12}>
                        <Form onSubmit={this.handleSubmit}>
                            <Form.Item
                                {...formItemLayout}
                                label="Email"
                            >
                                {getFieldDecorator('email', {
                                    initialValue: email,
                                    rules: [{ required: true }],
                                })(
                                    <Input disabled />,
                                )}
                            </Form.Item>
                            <Form.Item
                                {...formItemLayout}
                                label="Nombre"
                            >
                                {getFieldDecorator('name', {
                                    initialValue: this.props.name,
                                    rules: [{ required: true, message: 'Ingrese su Nombre' }],
                                })(
                                    <Input />,
                                )}
                            </Form.Item>
                            <Form.Item
                                {...formItemLayout}
                                label="Idioma"
                            >
                                {getFieldDecorator('language', {
                                    initialValue: lang,
                                    rules: [{ required: true }],
                                })(
                                    <Select>
                                        <Select.Option value="en">
                                            English
                                        </Select.Option>
                                        <Select.Option value="es">
                                            Español
                                        </Select.Option>
                                    </Select>,
                                )}
                            </Form.Item>
                            <Form.Item {...tailFormItemLayout}>
                                <Button type="primary" htmlType="submit">
                                    Guardar
                                </Button>
                            </Form.Item>
                        </Form>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default Form.create()(ProfileView);



// WEBPACK FOOTER //
// ./src/components/views/ProfileView.js